import clsx from 'clsx'

interface LogoProps {
  className?: string
  variant?: 'svg' | 'image'
  showText?: boolean
  text?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

export function Logo({ 
  className, 
  variant = 'svg', 
  showText = false, 
  text,
  size = 'md'
}: LogoProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  }

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-xl',
    xl: 'text-2xl'
  }

  if (variant === 'image') {
    return (
      <div className={clsx('flex items-center gap-x-2', className)}>
        <div className="relative">
          <img 
            src="/logo.svg" 
            alt="Simple CPRs Logo" 
            className={clsx(sizeClasses[size], 'flex-shrink-0')}
            style={{ display: 'none' }}
            onLoad={(e) => {
              const target = e.target as HTMLImageElement
              target.style.display = 'block'
              const svgFallback = target.nextElementSibling as HTMLElement
              if (svgFallback) svgFallback.style.display = 'none'
            }}
            onError={(e) => {
              const target = e.target as HTMLImageElement
              target.style.display = 'none'
              const svgFallback = target.nextElementSibling as HTMLElement
              if (svgFallback) svgFallback.style.display = 'block'
            }}
          />
          <svg
            aria-hidden="true"
            viewBox="0 0 32 32"
            className={clsx(sizeClasses[size], 'flex-shrink-0')}
          >
            <circle cx="16" cy="16" r="14" fill="#3B82F6" opacity="0.1"/>
            <circle cx="16" cy="16" r="12" fill="#3B82F6" opacity="0.2"/>
            <rect x="10" y="10" width="12" height="12" rx="2" fill="#3B82F6" opacity="0.9"/>
            <rect x="12" y="14" width="8" height="1" fill="white" rx="0.5"/>
            <rect x="12" y="16" width="6" height="1" fill="white" rx="0.5"/>
            <rect x="12" y="18" width="4" height="1" fill="white" rx="0.5"/>
            <circle cx="22" cy="12" r="1.5" fill="white" opacity="0.8"/>
          </svg>
        </div>
        {showText && (
          <span className={clsx('font-semibold text-slate-900', textSizeClasses[size])}>
            {text || import.meta.env.VITE_APPLICATION_NAME || 'Simple CPRs'}
          </span>
        )}
      </div>
    )
  }

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 32 32"
      className={clsx(sizeClasses[size], className)}
    >
      <circle cx="16" cy="16" r="14" fill="#3B82F6" opacity="0.1"/>
      <circle cx="16" cy="16" r="12" fill="#3B82F6" opacity="0.2"/>
      <rect x="10" y="10" width="12" height="12" rx="2" fill="#3B82F6" opacity="0.9"/>
      <rect x="12" y="14" width="8" height="1" fill="white" rx="0.5"/>
      <rect x="12" y="16" width="6" height="1" fill="white" rx="0.5"/>
      <rect x="12" y="18" width="4" height="1" fill="white" rx="0.5"/>
      <circle cx="22" cy="12" r="1.5" fill="white" opacity="0.8"/>
    </svg>
  )
} 